import { FC } from 'react'

import { styled } from 'styled-components'

import Clickable from 'core/components/lib/Clickable'

const RecoveryContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 12px;
`

const RecoveryMessage = styled.p`
  margin: 0;
  color: inherit;
  font-size: 14px;
`

type ErrorRecoveryActionsProps = {
  onRetry?: () => void
  className?: string
}

/**
 * Shared recovery action buttons for error fallbacks.
 * Provides "try again" and "reload page" options with helpful messaging.
 */
const ErrorRecoveryActions: FC<ErrorRecoveryActionsProps> = ({ onRetry, className }) => {
  if (!onRetry) return null

  return (
    <RecoveryContainer className={className}>
      <RecoveryMessage>
        Please{' '}
        <Clickable onClick={onRetry} variant='link'>
          try again
        </Clickable>
        , or{' '}
        <Clickable onClick={() => window.location.reload()} variant='link'>
          reload the page
        </Clickable>{' '}
        if the problem persists.
      </RecoveryMessage>
    </RecoveryContainer>
  )
}

export default ErrorRecoveryActions
